/* with love from shopstory */
var index$1 = require('./index-0b475274.js');
var React = require('react');
var ReactDOM = require('react-dom');
var styled = require('styled-components');
var ThumbnailButton = require('./ThumbnailButton-653e256d.js');
var contentful = require('contentful');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __jsx = React__default["default"].createElement;
var ModalRoot = styled__default["default"].div.withConfig({
  displayName: "mockMediaPicker__ModalRoot",
  componentId: "sc-1noc7b5-0"
})(["padding:16px;"]);
var Notice = styled__default["default"].div.withConfig({
  displayName: "mockMediaPicker__Notice",
  componentId: "sc-1noc7b5-1"
})(["", " max-width:500px;margin:40px 0 60px;"], index$1.SSFonts.bodyLarge);
var GridRoot = styled__default["default"].div.withConfig({
  displayName: "mockMediaPicker__GridRoot",
  componentId: "sc-1noc7b5-2"
})(["display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));grid-column-gap:30px;grid-row-gap:30px;"]);
var CardTitle = styled__default["default"].div.withConfig({
  displayName: "mockMediaPicker__CardTitle",
  componentId: "sc-1noc7b5-3"
})(["margin-top:12px;", ""], index$1.SSFonts.body);
var FieldMessage = styled__default["default"].div.withConfig({
  displayName: "mockMediaPicker__FieldMessage",
  componentId: "sc-1noc7b5-4"
})(["", " color:", ";white-space:normal;margin-bottom:12px;"], index$1.SSFonts.body, index$1.SSColors.black40);
var PLAYGROUND_MESSAGE = "This is the playground media picker. In production Shopstory would connect to the media picker of your CMS.";
styled__default["default"].div.withConfig({
  displayName: "mockMediaPicker__GroupTitle",
  componentId: "sc-1noc7b5-5"
})(["", " margin-bottom:12px;"], index$1.SSFonts.label);
var Card = styled__default["default"].div.withConfig({
  displayName: "mockMediaPicker__Card",
  componentId: "sc-1noc7b5-6"
})(["&:hover{outline:1px solid ", ";}outline-offset:4px;cursor:pointer;"], index$1.SSColors.black40);

function CardsGroup(props) {
  return __jsx("div", {
    style: {
      marginTop: "40px"
    }
  }, __jsx(GridRoot, null, props.items.map(function (item) {
    return __jsx(Card, {
      onClick: function onClick() {
        props.onSelect(item);
      }
    }, __jsx("div", {
      style: {
        paddingBottom: "100%",
        background: "#eaeaea",
        overflow: "hidden",
        position: "relative"
      }
    }, item.thumbnail && __jsx("img", {
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        objectFit: "contain"
      },
      src: item.thumbnail
    })), __jsx(CardTitle, null, item.title));
  })));
}

var Component = function Component(props) {
  var id = props.value.id;

  var _useState = React.useState(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  var _useState2 = React.useState(null),
      items = _useState2[0],
      setItems = _useState2[1];

  var selectedItem = items && items.find(function (item) {
    return item.id === props.value.id;
  });
  React.useEffect(function () {
    props.fetcher().then(function (images) {
      setItems(images);
    });
  }, []);
  var label = "Pick media";

  if (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.isVideo) {
    label = "Video";
  } else if ((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.mimeType) === "image/svg+xml") {
    label = "SVG";
  } else if (selectedItem) {
    label = "Image'";
  }

  return __jsx("div", null, __jsx(FieldMessage, null, PLAYGROUND_MESSAGE), items === null && __jsx(ThumbnailButton.ThumbnailButton, {
    label: "Loading...",
    disabled: true
  }), items !== null && __jsx(ThumbnailButton.ThumbnailButton, {
    onClick: function onClick() {
      setOpen(true);
    },
    label: label,
    description: selectedItem ? selectedItem.title : undefined,
    thumbnail: selectedItem && selectedItem.thumbnail ? {
      type: "image",
      src: selectedItem.thumbnail
    } : undefined
  }), __jsx(index$1.SSModal, {
    title: "Playground media picker",
    isOpen: isOpen,
    onRequestClose: function onRequestClose() {
      setOpen(false);
    },
    mode: "center-huge",
    headerLine: true
  }, __jsx(ModalRoot, null, __jsx(Notice, null, __jsx("strong", null, "Important!"), " ", PLAYGROUND_MESSAGE), __jsx(CardsGroup, {
    onSelect: function onSelect(item) {
      props.onChange({
        id: item.id
      });
      setOpen(false);
    },
    items: items !== null && items !== void 0 ? items : []
  }))), __jsx("div", {
    style: {
      marginTop: "12px",
      display: "flex",
      flexDirection: "row",
      gap: "8px"
    }
  }, id !== null && __jsx(index$1.SSButtonSecondary, {
    onClick: function onClick() {
      props.onChange({
        id: null
      });
    }
  }, "Clear")));
};

function mockMediaPicker(fetcher, key) {
  return {
    type: "custom",
    component: function component(_ref) {
      var root = _ref.root,
          onChange = _ref.onChange,
          value = _ref.value;
      ReactDOM__default["default"].render(__jsx(Component, {
        value: value,
        onChange: onChange,
        fetcher: fetcher,
        key: key
      }), root);
    }
  };
}

function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { index$1._defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function createContentfulClient() {
  return contentful.createClient({
    space: "blh4anz05qu1",
    accessToken: "lYW4u-PLH0lAAzFqWUwfSluHeC-jL1MF0XIoTYlXAjI",
    host: undefined
  });
}

function fetchImages() {
  return _fetchImages.apply(this, arguments);
}

function _fetchImages() {
  _fetchImages = index$1._asyncToGenerator( /*#__PURE__*/index$1.regenerator.mark(function _callee4() {
    var contentfulClient, entries, images;
    return index$1.regenerator.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            contentfulClient = createContentfulClient();
            _context4.next = 3;
            return contentfulClient.getEntries({
              content_type: "playgroundImages",
              include: 2
            });

          case 3:
            entries = _context4.sent;
            images = entries.items[0].fields.images;
            return _context4.abrupt("return", images.map(function (image) {
              return {
                id: image.sys.id,
                title: image.fields.title,
                url: "https:".concat(image.fields.file.url, "?fm=webp&w=1920"),
                thumbnail: "https:".concat(image.fields.file.url, "?fm=webp&w=400"),
                width: image.fields.file.details.image.width,
                height: image.fields.file.details.image.height,
                mimeType: image.fields.file.contentType,
                isVideo: false
              };
            }));

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _fetchImages.apply(this, arguments);
}

function fetchVideos() {
  return _fetchVideos.apply(this, arguments);
}

function _fetchVideos() {
  _fetchVideos = index$1._asyncToGenerator( /*#__PURE__*/index$1.regenerator.mark(function _callee5() {
    var contentfulClient, entries, videos;
    return index$1.regenerator.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            contentfulClient = createContentfulClient();
            _context5.next = 3;
            return contentfulClient.getEntries({
              content_type: "playgroundImages",
              include: 3
            });

          case 3:
            entries = _context5.sent;
            videos = entries.items[0].fields.videos;
            return _context5.abrupt("return", videos.map(function (video) {
              return {
                id: video.sys.id,
                title: video.fields.title,
                thumbnail: "https:".concat(video.fields.poster.fields.file.url, "?fm=webp&w=400"),
                width: video.fields.width,
                height: video.fields.height,
                url: "https:".concat(video.fields.video.fields.file.url),
                mimeType: video.fields.video.fields.file.contentType,
                isVideo: true
              };
            }));

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _fetchVideos.apply(this, arguments);
}

function getLocale() {
  var urlSearchParams = new URLSearchParams(typeof window === "object" ? window.location.search : "");
  var params = Object.fromEntries(urlSearchParams.entries());
  var locale = typeof params.locale === "string" ? params.locale : undefined;
  return locale !== null && locale !== void 0 ? locale : "en";
}

var noCMSPlugin = {
  id: "nocms",
  resources: {
    "nocms.image": {
      defaultFetch: function () {
        var _defaultFetch = index$1._asyncToGenerator( /*#__PURE__*/index$1.regenerator.mark(function _callee(resources) {
          var assets;
          return index$1.regenerator.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return fetchImages();

                case 2:
                  assets = _context.sent;
                  return _context.abrupt("return", resources.map(function (resource) {
                    return _objectSpread(_objectSpread({}, resource), {}, {
                      value: assets.find(function (asset) {
                        return asset.id === resource.id;
                      })
                    });
                  }));

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function defaultFetch(_x) {
          return _defaultFetch.apply(this, arguments);
        }

        return defaultFetch;
      }(),
      widget: mockMediaPicker(fetchImages, "images")
    },
    "nocms.video": {
      defaultFetch: function () {
        var _defaultFetch2 = index$1._asyncToGenerator( /*#__PURE__*/index$1.regenerator.mark(function _callee2(resources) {
          var assets;
          return index$1.regenerator.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return fetchVideos();

                case 2:
                  assets = _context2.sent;
                  return _context2.abrupt("return", resources.map(function (resource) {
                    return _objectSpread(_objectSpread({}, resource), {}, {
                      value: assets.find(function (asset) {
                        return asset.id === resource.id;
                      })
                    });
                  }));

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function defaultFetch(_x2) {
          return _defaultFetch2.apply(this, arguments);
        }

        return defaultFetch;
      }(),
      widget: mockMediaPicker(fetchVideos, "videos")
    }
  },
  launcher: {
    image: {
      resourceType: "nocms.image",
      transform: function transform(x) {
        return {
          url: x.url,
          alt: x.title,
          aspectRatio: x.width / x.height,
          mimeType: x.mimeType,
          srcset: [{
            w: x.width,
            h: x.height,
            url: x.url
          }]
        };
      }
    },
    video: {
      resourceType: "nocms.video",
      transform: function transform(x) {
        return {
          url: x.url,
          alt: x.title,
          aspectRatio: x.width / x.height
        };
      }
    },
    onEditorLoad: function onEditorLoad(launchEditor) {
      var _window, _window2;

      launchEditor({
        onClose: function onClose() {
          alert("good bye bye");
        },
        save: function () {
          var _save = index$1._asyncToGenerator( /*#__PURE__*/index$1.regenerator.mark(function _callee3(configs, externals) {
            return index$1.regenerator.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    console.debug("saving config...");
                    _context3.next = 3;
                    return sleep(1000);

                  case 3:
                    window.noCmsConfig = configs;
                    window.noCmsExternals = externals;
                    console.debug("saved config!");

                  case 6:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          function save(_x3, _x4) {
            return _save.apply(this, arguments);
          }

          return save;
        }(),
        locales: [{
          code: "en",
          isDefault: true
        }, {
          code: "pl",
          fallback: "en"
        }],
        contextParams: {
          locale: getLocale()
        },
        configs: (_window = window) === null || _window === void 0 ? void 0 : _window.noCMSInputConfigs,
        mode: (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.noCMSMode
      });
    }
  }
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  noCMSPlugin: noCMSPlugin
});

exports.index = index;
exports.noCMSPlugin = noCMSPlugin;
exports.sleep = sleep;
